import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findIndex } from 'lodash';
import { removeNotification } from '../../store/notificationsSlice';
import { Notification } from './Notification';

const errorList = {
    413: "The file is too big. Please upload a smaller file or contact VSI support.",
    500: "Internal server error. Please contact VSI support."
};

const NotificationContainer = () => {
    const dispatch = useDispatch();
    const { notifications } = useSelector(state => state.notifications);

    const [ visible, setVisible ] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (notifications.length) {
                let idx = findIndex(notifications, { closable: true });
                if (idx > -1) dispatch(removeNotification(notifications[idx].id));
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [ notifications.length ]);


    return(
        notifications.length
            ? notifications.map(notification =>
                <Notification
                    key={notification.id}
                    type={notification.type || "info"}
                    code={notification.code}
                    notificationId={notification.id}
                    message={notification.code && errorList.hasOwnProperty(notification.code) ? errorList[notification.code] : notification.message}
                    onClose={(id) => dispatch(removeNotification(id))}
                    log={notification.log}
                    link={notification.link}
                    showLog={(id) => setVisible(id)}
                    visible={visible === notification.id}
                    onCloseLog={() => setVisible(false)}
                />
                )
            : null
    )
};

export { NotificationContainer };